import { useEffect, useState } from "react";
import { api, queryString } from "../api.js";
import { ErrorBox, Pager, fmtRelative } from "../components/helpers.jsx";

const LIMIT = 50;

export default function KernelFailures() {
    const [data, setData] = useState({ rows: [], total: 0 });
    const [offset, setOffset] = useState(0);
    const [err, setErr] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get("/api/admin/kernel-failures" + queryString({ limit: LIMIT, offset }))
            .then((d) => { if (alive) setData(d); })
            .catch((e) => { if (alive) setErr(e.message); });
        return () => { alive = false; };
    }, [offset]);

    return (
        <>
            <div className="page-header">
                <div>
                    <h1>Kernel read failures</h1>
                    <div className="sub">khwid modules that returned ok=false — work list for offset updates.</div>
                </div>
            </div>

            <ErrorBox>{err}</ErrorBox>

            <div className="table-wrap">
                <table className="data">
                    <thead>
                        <tr>
                            <th>When</th>
                            <th>Windows build</th>
                            <th>Module</th>
                            <th>Subject</th>
                            <th>Reason</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.rows.length === 0 && (
                            <tr><td colSpan={5} className="text-dim" style={{ padding: 24, textAlign: "center" }}>
                                No failures recorded
                            </td></tr>
                        )}
                        {data.rows.map((r) => (
                            <tr key={r.id}>
                                <td title={new Date(r.createdAt).toLocaleString()}>{fmtRelative(r.createdAt)}</td>
                                <td className="mono">{r.windowsBuild}</td>
                                <td className="mono">{r.module}</td>
                                <td className="mono">{r.subject}</td>
                                <td className="text-dim">{r.reason ?? "—"}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager total={data.total} limit={LIMIT} offset={offset} onChange={setOffset} />
            </div>
        </>
    );
}
